/** Slug of the default home feed tab ("All"). */
export const HOME_FEED_SLUG = 'home';

/** Active home tab slug — the feed (`HOME_FEED_SLUG`) or a tool from `HOME_TOOLS`. */
export type HomeTab = string;

export interface HomeTabsSlice {
  activeHomeTab: HomeTab;
  hideHomeTabs: boolean;
  setActiveHomeTab: (tab: HomeTab) => void;
}
